import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    requestIdleCallback(() => this.#spawn())
  }

  #spawn() {
    const colors = ["#C0623A", "#D3835F", "#E3A88E", "#A44F2D", "#F0CBBB", "#ff6b6b", "#feca57", "#48dbfb", "#ff9ff3"]
    const container = document.createElement("div")
    container.className = "fixed inset-0 z-[100] pointer-events-none overflow-hidden"

    for (let i = 0; i < 60; i++) {
      const piece = document.createElement("div")
      const color = colors[Math.floor(Math.random() * colors.length)]
      const left = Math.random() * 100
      const delay = Math.random() * 0.8
      const duration = 2 + Math.random() * 2
      const size = 6 + Math.random() * 6
      const rotation = Math.random() * 360

      piece.style.cssText = `
        position: absolute;
        top: -10px;
        left: ${left}%;
        width: ${size}px;
        height: ${size * 0.6}px;
        background: ${color};
        border-radius: 2px;
        transform: rotate(${rotation}deg);
        animation: confetti-fall ${duration}s ease-in ${delay}s forwards;
      `
      container.appendChild(piece)
    }

    document.body.appendChild(container)
    setTimeout(() => container.remove(), 4000)
  }
}
